var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.floatLabel
        ? _c(
            "label",
            {
              staticClass: "caption pl-2.5 soli-grey justify-start flex",
              attrs: { for: "email" },
            },
            [_vm._v("Your email address")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("SoliText", {
        ref: "email",
        attrs: {
          value: _vm.value,
          name: "email",
          label: _vm.floatLabel ? null : "Your email address",
          outlined: "",
          rules: _vm.emailRules,
          "hide-details": _vm.hideDetails,
          icon: _vm.icon ? _vm.alternate_email : null,
          prevent: _vm.prevent,
          errors: _vm.errors,
          autofocus: _vm.autofocus,
        },
        on: {
          input: function ($event) {
            return _vm.$emit("input", $event)
          },
          "update:error": function ($event) {
            return _vm.validate($event)
          },
          "hook:mounted": function ($event) {
            return _vm.$emit("mounted")
          },
          keydown: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.$emit("keydown", $event)
          },
          blur: _vm.blurInput,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }